import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CreditCardOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"credit_card_off"}/>
}
